module.exports = __webpack_public_path__ + "static/media/upload.31d3959d.png";